/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReferencedComponent from '../ComponentReference/ReferencedComponent';
import NodeReferenceData from './NodeReferenceData';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class NodeReferenceList extends ReferencedComponent
{
    @property({ type: [NodeReferenceData] })
    protected nodeReferences: NodeReferenceData[] = [];
    /** Returns list with key: grouped by node and value: grouped node. */
    public get Nodes(): cc.Node[]
    {
        let nodes: cc.Node[] = [];
        this.nodeReferences.forEach(nodeReference =>
        {
            if (!nodeReference.Value) { return; }
            nodes.push(nodeReference.Value);
        });
        return nodes;
    }

    public get length(): number { return this.nodeReferences.length; }

    public Clear(): void { this.nodeReferences.length = 0; }

    public InsertAtBeginning(node: cc.Node): void
    {
        let newNodeList: NodeReferenceData[] = [new NodeReferenceData()];
        newNodeList[0].Node = node;

        newNodeList.push(...this.nodeReferences);
        this.nodeReferences = newNodeList;
    }

    public Add(node: cc.Node): void
    {
        let newNodeRef: NodeReferenceData = new NodeReferenceData();
        newNodeRef.Node = node;

        this.nodeReferences.push(newNodeRef);
    }
}
